import { dateFormatShortDate, toDayEnd } from '@nx-smartmonkey/shared/helpers';
import { RoutalPalette } from '@nx-smartmonkey/ui';
import { useState } from 'react';
import { Range } from 'react-date-range';
import { useSearchParams } from 'react-router-dom';
import styled from 'styled-components';

import { Grid } from '@mui/material';
import { HeaderContent } from '../../../components/HeaderContent';
import { useAnalyticsFilters } from '../../../hooks/analytics/useAnalyticsFilters';
import { useRetrieveActiveProject } from '../../../hooks/project/useRetrieveActiveProject';
import Button from '../../../react-components/Button';
import Text from '../../../react-components/Text';
import { DateRangePicker } from '../../../react-components/date-range-picker/DateRangePicker';

export const AnalyticsHeaderContainer = styled.div`
  max-height: 117px;
  background-color: ${RoutalPalette.neutral00};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid ${RoutalPalette.grey4};
`;

interface AnalyticsHeaderProps {
  titleIntlId: string;
}

const AnalyticsHeader = ({ titleIntlId }: AnalyticsHeaderProps) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const { data: activeProject } = useRetrieveActiveProject();
  const { startDate, endDate } = useAnalyticsFilters({ project: activeProject });
  const [datePickerPosition, setDatePickerPosition] = useState<{ top: number; left: number } | undefined>(undefined);

  return (
    <Grid
      container
      direction="column"
      style={{
        padding: `11px 20px`,
        backgroundColor: RoutalPalette.neutral02n,
        borderBottom: `1px solid ${RoutalPalette.neutral10}`,
      }}
      wrap="nowrap"
    >
      <Grid container direction="row" wrap="nowrap">
        <HeaderContent
          titleIntlId={titleIntlId}
          styles={{
            container: {
              display: `flex`,
              flexDirection: `column`,
              justifyContent: `center`,
            },
          }}
        />

        <Grid container direction="row" wrap="nowrap" justifyContent="flex-end">
          <Button
            id="analytics-date-picker-button"
            styleType="secondary"
            variant="flat"
            size="xs"
            style={{
              backgroundColor: `transparent`,
              height: `26px`,
              borderColor: RoutalPalette.neutral20,
              borderRadius: `5px`,
              width: `175px`,
            }}
            onClick={(e: any) => {
              const datePickerButton = document.getElementById(`analytics-date-picker-button`);
              if (!datePickerButton) return;

              const { x, bottom } = datePickerButton.getBoundingClientRect();
              setDatePickerPosition({ top: bottom, left: x });
            }}
          >
            <Text style={{ cursor: `pointer` }}>
              {`${dateFormatShortDate(startDate)} - ${dateFormatShortDate(endDate)}`}
            </Text>
          </Button>
        </Grid>
      </Grid>

      <DateRangePicker
        id="select-dates"
        popoverPosition={datePickerPosition}
        startDate={startDate}
        endDate={endDate}
        onClose={() => {
          setDatePickerPosition(undefined);
        }}
        onUpdate={(range: Range) => {
          if (range.startDate) searchParams.set(`start_date`, `${range.startDate.toUTCString()}`);
          if (range.endDate) searchParams.set(`end_date`, `${toDayEnd(range.endDate).toUTCString()}`);
          setSearchParams(searchParams);
        }}
      />
    </Grid>
  );
};

export default AnalyticsHeader;
